import { render, staticRenderFns } from "./Vet.vue?vue&type=template&id=062d496e&"
import script from "./Vet.vue?vue&type=script&lang=js&"
export * from "./Vet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports